import React from "react";
import SkipNextIcon from '@mui/icons-material/SkipNext';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import styles from './Controls.module.scss';
import {PlayerEventBus} from "../../../playerEventBus";
import IconButton from "@mui/material/IconButton";
import {CircularProgress} from "@mui/material";
import QueueMusicIcon from '@mui/icons-material/QueueMusic';
import {usePlayerDispatch, usePlayerSelector} from "../../../../../../store/slices/player/playerSlice";
import {PauseCircle} from "@mui/icons-material";
import {SpinnerControl} from "../../spinnerControl/SpinnerControl";
import {updateShuffle} from "../../../../../../store/slices/player/actions";
import {Link} from "react-router-dom";
import {CastButton} from "../../../../../../native/cast/CastButton";

export interface ControlsProps {
    minimalView: boolean;
    isFullScreen: boolean;
}

export const Controls: React.FC<ControlsProps> = ({minimalView, isFullScreen}) => {
    const playerDispatch = usePlayerDispatch();
    const {nowPlaying, status, shuffle} = usePlayerSelector(['nowPlaying', 'status', 'shuffle'])

    const showPlay = status === 'Paused' || status === 'Unstarted';
    const showPause = status === 'Playing';
    const showBuffering = !showPlay && !showPause;

    const handlePlayClicked = (e: React.MouseEvent) => {
        e.stopPropagation();
        PlayerEventBus.emit('play');
    };
    const handlePauseClicked = (e: React.MouseEvent) => {
        e.stopPropagation();
        PlayerEventBus.emit('pause');
    };
    const handleNextClicked = (e: React.MouseEvent) => {
        e.stopPropagation();
        PlayerEventBus.emit('next');
    };
    const handlePrevClicked = (e: React.MouseEvent) => {
        e.stopPropagation();
        PlayerEventBus.emit('prev');
    };
    const handleShuffleClicked = (e: React.MouseEvent) => {
        e.stopPropagation();
        playerDispatch(updateShuffle(!shuffle));
    };

    if (minimalView && !isFullScreen) {
        return (<div className={styles.controls__container}>
            <CastButton size={22}/>
            <IconButton
                className={styles.controls__playButton}
                aria-label={showPause ? 'Pause' : 'Play'}
                onClick={showPause ? handlePauseClicked : handlePlayClicked}
            >
                {showBuffering && <CircularProgress size={22} thickness={5} sx={{color: 'white'}}/>}
                {showPause && <PauseIcon sx={{fontSize: 22, color: 'white'}}/>}
                {showPlay && <PlayArrowIcon sx={{fontSize: 24, color: 'white', marginLeft: '1px'}}/>}
            </IconButton>
            <IconButton aria-label="Next" onClick={handleNextClicked}>
                <SkipNextIcon className={styles.controls__skip} sx={{fontSize: 28}}/>
            </IconButton>
        </div>);
    }

    return (
        <div className={styles.controls__container}>
            <IconButton aria-label="Shuffle" onClick={handleShuffleClicked}>
                <ShuffleIcon className={shuffle ? styles.controls__shuffleOn : ''} sx={{fontSize: 16}}/>
            </IconButton>
            <IconButton aria-label="Previous" onClick={handlePrevClicked}>
                <SkipPreviousIcon
                    className={styles.controls__skip} sx={{fontSize: 28}}/>
            </IconButton>
            {showPlay && <IconButton aria-label="Play" onClick={handlePlayClicked}>
                <PlayCircleIcon
                    sx={{fontSize: isFullScreen ? 60 : 38.5, color: 'white'}}/>
            </IconButton>}
            {showPause && <IconButton aria-label="Pause" onClick={handlePauseClicked}>
                <PauseCircle
                    sx={{fontSize:  isFullScreen ? 60 : 38.5, color: 'white'}}/>
            </IconButton>}
            {showBuffering && <SpinnerControl isFullScreen={isFullScreen}/>}
            <IconButton aria-label="Next" onClick={handleNextClicked}>
                <SkipNextIcon className={styles.controls__skip} sx={{fontSize: 28}}/>
            </IconButton>
            <Link to={`/playlists/${nowPlaying?.playlist.id}`}>
                <IconButton aria-label="Shuffle">
                    <QueueMusicIcon sx={{fontSize: 18}}/>
                </IconButton>
            </Link>
            <CastButton size={20}/>
        </div>
    );
};

